const levels = [1, 2, 3, 4]
const tables = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

type OperatorType = "+" | "-" | "*" | "/"

export type OperatorOptions = {
    tables?: number[]
    levels?: number[]
    all?: boolean
    shuffle?: boolean
    ready?: boolean
    helper?: boolean
}

export type TrainingOptions = {
    Tables: number[],
    Shuffle: boolean,
    Helper: boolean,
    reset?: boolean,
    ready?: boolean,
}

function goBack() {
    window.history.back();
}

// export function setTableLevelSelection(selectedOptions?: TrainingOptions, data?: { value: number, category: string }) {
    // console.log('Data on Selected', data.category, data.value )


    //
    // if (data.category === "Tables" || data.category === "Levels") {
    //     selectedObj[data.category] = selectedObj[data.category] ?? [];
    //     if (selectedObj[data.category].includes(data.value)) {
    //         selectedObj[data.category] = selectedObj[data.category].filter(item => item !== data.value);
    //     }
    //     else {
    //         selectedObj[data.category].push(data.value);
    //     }
    // }
    //
    //
    // if (data.category === "Helper" || data.category === "Shuffle") {
    //     selectedObj[data.category] = selectedObj[data.category] ?? [];
    //     if (selectedObj[data.category].length > 0) {
    //         selectedObj[data.category][0] = selectedObj[data.category][0] === 1 ? 0 : 1;
    //     } else {
    //         selectedObj[data.category].push(data.value);
    //     }
    // // }
    //
    // console.log('Selected Options', selectedObj)
    // return onReadyClick(selectedObj);
// }



export function onReadyClick(selectedOptions?: TrainingOptions, operation?: OperatorType) {
    console.log('Selected Options', selectedOptions)
    const selectedObj: TrainingOptions = {
        Tables: selectedOptions?.Tables ?? [1, 2],
        Shuffle: selectedOptions?.Shuffle ?? false,
        Helper: selectedOptions?.Helper ?? false,
    };
    if (selectedObj?.Tables.length) {
        const selectedTables = selectedObj.Tables ?? [];
        const sortedSelectedTables = selectedTables.sort((a, b) => a - b);
        const _options: OperatorOptions = {
            tables: sortedSelectedTables,
            shuffle: selectedObj.Shuffle,
            helper: selectedObj.Helper,
            ready: true
        };
        console.log('Options', _options)

        switch (operation) {
            case "*":
                return generateMultiplicationQuestions(_options);
            case "/":
                return generateDivisionQuestions(_options);
            case "+":
                return generateAdditionQuestions(_options);
            case "-":
                return generateSubtractionQuestions(_options);
            default:
                return undefined
        }
    }
}

export function generateMultiplicationQuestions(options: OperatorOptions) {
    if (options?.ready && options?.tables) {
        const multiplicands = Array.from(
            { length: 13 },
            (_, i) => i
        ).sort((a, b) => a - b)

        const multipliers = options.tables
        if (options.shuffle) {
            for (let i = multiplicands.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [multiplicands[i], multiplicands[j]] = [multiplicands[j], multiplicands[i]];
            }

            for (let i = multipliers.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [multipliers[i], multipliers[j]] = [multipliers[j], multipliers[i]];
            }
        }

        const _questions = [] as number[][]

        multipliers.forEach((multiplicand) => {
            multiplicands.forEach((multiplier) => {
                _questions.push([multiplier, multiplicand])
            })
        })

        if (options.shuffle) {
            for (let i = _questions.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [_questions[i], _questions[j]] = [_questions[j], _questions[i]];
            }
        }

        console.log(_questions)

        return _questions
    }
}

export function generateDivisionQuestions(options: OperatorOptions) {
    if (options?.ready && options?.tables) {
        const _questions = [] as number[][]
        const divisors: number[] = options.tables

        const quotients = Array.from(
            { length: 13 },
            (_, i) => i
        ).sort((a, b) => a - b)

        divisors.forEach((divisor) => {
            quotients.forEach(quotient => {
                _questions.push([quotient * divisor, divisor])
            })
        })

        if (options.shuffle) {
            for (let i = _questions.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [_questions[i], _questions[j]] = [_questions[j], _questions[i]];
            }
        }

        console.log(_questions)

        return _questions
    }
}

export function generateAdditionQuestions(options: OperatorOptions) {
    if (options?.ready && options?.tables) {
        const addend: number[] = options.tables
        const addend2 = Array.from(
            { length: 13 },
            (_, i) => i
        ).sort((a, b) => a - b)
        const _questions = [] as number[][]

        addend.forEach(a => {
            addend2.forEach(b => {
                _questions.push([a, b])
            })
        })

        if (options.shuffle) {
            for (let i = _questions.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [_questions[i], _questions[j]] = [_questions[j], _questions[i]];
            }
        }

        console.log(_questions)

        return _questions
    }
}

export function generateSubtractionQuestions(options: OperatorOptions) {
    if (options?.ready && options?.tables) {
        const subtrahend: number[] = options.tables
        const difference = Array.from(
            { length: 13 },
            (_, i) => i
        ).sort((a, b) => a - b)
        const _questions = [] as number[][]

        subtrahend.forEach(s => {
            difference.forEach(d => {
                _questions.push([s + d, s])
            })
        })

        // const multipliers = options.tables
        // if (options.shuffle) {
        //     for (let i = multiplicands.length - 1; i > 0; i--) {
        //         const j = Math.floor(Math.random() * (i + 1));
        //         [multiplicands[i], multiplicands[j]] = [multiplicands[j], multiplicands[i]];
        //     }
        //
        //     for (let i = multipliers.length - 1; i > 0; i--) {
        //         const j = Math.floor(Math.random() * (i + 1));
        //         [multipliers[i], multipliers[j]] = [multipliers[j], multipliers[i]];
        //     }
        // }
        // multipliers.forEach((multiplicand) => {
        //     multiplicands.forEach((multiplier) => {
        //         _questions.push([multiplier, multiplicand])
        //     })
        // })

        if (options.shuffle) {
            for (let i = _questions.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [_questions[i], _questions[j]] = [_questions[j], _questions[i]];
            }
        }

        console.log(_questions)

        return _questions
    }
}